import axios from 'axios';
import properties from '../../properties';

export const getSummary = async (
  eg_nid: string,
  incurred_start_date: string,
  incurred_end_date: string,
  paid_start_date: string,
  paid_end_date: string,
) => {
  return await axios.post(
    properties.aiqBaseUrl +
      properties.paymentIntegrityBaseURL +
      properties.getPaymentIntegritySummary,
    {
      eg_nid,
      incurred_start_date,
      incurred_end_date,
      paid_start_date,
      paid_end_date,
    },
  );
};

export const getCategories = async (
  eg_nid: string,
  start_date: string,
  end_date: string,
) => {
  return await axios.post(
    properties.aiqBaseUrl +
      properties.paymentIntegrityBaseURL +
      properties.getCategories,
    { eg_nid, start_date, end_date },
  );
};

export const getCategoryDetails = async (
  eg_nid: string,
  category: string,
  start_date: string,
  end_date: string,
  pageNumber: Number,
  pageSize?: Number,
  sortField?: string,
  sortOrder?: Number,
) => {
  return await axios.post(
    properties.aiqBaseUrl +
      properties.paymentIntegrityBaseURL +
      properties.getCategoryDetails,
    {
      eg_nid,
      category,
      start_date,
      end_date,
      pageNumber,
      pageSize,
      sortField,
      sortOrder,
    },
  );
};
